import React from 'react'
import { useAppSetting } from '@ztechapps/common.hook'
import type { AppSettingInlineInputProps } from './AppSettingInlineInput'
import { AppSettingInlineInput } from './AppSettingInlineInput'
import { DataSuspense } from '@ztechapps/webui.util'
import type { SetOptional } from 'type-fest'

export type AppSettingInlineInputWithValueProps = {
  appSettingKey: string
  filter?: Record<any, any>
} & SetOptional<AppSettingInlineInputProps, 'initialValues'>

/**
 * Wraps the inline AppSetting inline input, with actual retrieval from the app setting repository by just providing the key
 * All the props of AppSettingInlineInput can be passed here
 */
export const AppSettingInlineInputWithValue = ({
  appSettingKey,
  filter,
  ...rest
}: AppSettingInlineInputWithValueProps) => {
  const { setting, loading } = useAppSetting({ appSettingKey, filter })

  return (
    <DataSuspense loading={loading}>
      <AppSettingInlineInput {...{ ...rest, initialValues: setting }} />
    </DataSuspense>
  )
}
